import React from 'react';
import DividendCalculator from '../components/calculators/DividendCalculator';
import FAQ from '../components/FAQ';
import SEO from '../components/shared/SEO';

const DividendPage: React.FC = () => {
  const faqs = [
    {
      question: "What is dividend investing?",
      answer: "Dividend investing is a strategy where investors buy stocks that regularly pay dividends, providing a steady stream of passive income alongside potential capital appreciation."
    },
    {
      question: "What is dividend yield?",
      answer: "Dividend yield is the annual dividend payment divided by the stock price, expressed as a percentage. For example, a stock paying $2 in annual dividends with a $50 share price has a 4% dividend yield."
    },
    {
      question: "What is dividend growth?",
      answer: "Dividend growth refers to companies increasing their dividend payments over time. Many established companies aim to increase dividends annually, providing growing income to shareholders."
    },
    {
      question: "Should I reinvest dividends?",
      answer: "Reinvesting dividends can significantly boost long-term returns through compound growth. However, some investors prefer receiving dividends as income. The choice depends on your financial goals."
    },
    {
      question: "What factors aren't included in this calculator?",
      answer: "This calculator doesn't account for taxes, inflation, changes in stock price, or potential dividend cuts. Companies can change or eliminate dividends based on business conditions."
    }
  ];

  return (
    <>
      <SEO 
        title="Dividend Income Calculator"
        description="Calculate your potential dividend income and growth. Plan your dividend investment strategy and track passive income."
        keywords={[
          'dividend calculator',
          'dividend investing',
          'dividend yield',
          'dividend growth',
          'passive income',
          'dividend reinvestment',
          'DRIP calculator',
          'dividend stocks',
          'income investing',
          'investment planning'
        ]}
        canonicalPath="/dividend"
      />
      <DividendCalculator />
      <FAQ faqs={faqs} />
    </>
  );
};

export default DividendPage;